import styled from 'styled-components'
import { FormLabel } from '@compeon-os/components'

const StyledFormLabel = styled(FormLabel)`
  font-weight: bold;
`

export default StyledFormLabel
